export default {
    "help.title": "Help Center & Frequently Asked Questions (FAQ) - CitoyenPro",
    "help.seo_description": "Need help? Check out our Help Center and FAQ for quick answers regarding your Canadian citizenship exam preparation and subscriptions.",
    "help.hero.title": "How can we help you?",
    "help.nav.back_home": "Back to Home",

    "help.categories.account.title": "Account & Login",
    "help.categories.account.desc": "Password issues, confirmation email not received, profile settings.",
    "help.categories.billing.title": "Billing & Subscription",
    "help.categories.billing.desc": "Change plan, cancel subscription, invoices, refunds.",
    "help.categories.content.title": "Content & Courses",
    "help.categories.content.desc": "Questions about the official guide, how quizzes work, mock exams.",
    "help.categories.support.title": "Technical Support",
    "help.categories.support.desc": "Report a bug, display issue, slow application.",

    "help.faq.title": "Common Questions",
    "help.faq.q1": "How do I reset my password?",
    "help.faq.a1": "If you've forgotten your password, click 'Forgot password' on the login page. You'll receive an email to create a new one.",
    "help.faq.q2": "Does the app work offline?",
    "help.faq.a2": "Currently, an internet connection is required for interactive quizzes. However, Standard and Premium subscribers can download PDFs for offline study.",
    "help.faq.q3": "How do I cancel my subscription?",
    "help.faq.a3": "You can cancel at any time from your Dashboard > My Subscription. Access remains active until the end of the paid period.",
    "help.faq.q4": "Can I read the official book from the app?",
    "help.faq.a4": "Yes! We have integrated a full EPUB reader for the 'Discover Canada' guide. This feature is completely free for all users (including the Free plan). You will find the book directly in your dashboard's navigation bar.",

    "help.contact.title": "Can't find your answer?",
    "help.contact.desc": "Our support team is here to help you Monday through Friday.",
    "help.contact.cta": "Contact Support"
};
